/**
 * MUI Toolbar component overrides.
 */
import { Components, Theme } from "@mui/material/styles";

export const toolbarOverrides: Pick<Components<Theme>, "MuiToolbar"> = {
  MuiToolbar: {
    styleOverrides: {
      // Consistent dense toolbar height used by the app header
      dense: {
        height: 60,
        minHeight: 60
      }
    }
  }
};
